/**
 * Sidebar Icon
 *
 */

import React from 'react'

export default function elements(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 21.75C1.85218 21.75 1.47064 21.592 1.18934 21.3107C0.908035 21.0294 0.75 20.6478 0.75 20.25V3.865C0.751319 3.43708 0.921893 3.02707 1.22448 2.72448C1.52707 2.42189 1.93708 2.25132 2.365 2.25H21.643C22.0688 2.25132 22.4768 2.42105 22.7779 2.72214C23.079 3.02322 23.2487 3.4312 23.25 3.857V20.135C23.2487 20.5629 23.0781 20.9729 22.7755 21.2755C22.4729 21.5781 22.0629 21.7487 21.635 21.75H2.25Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.25 6.75H0.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 11.25L19.5 14.25L16.5 17.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 11.25L4.5 14.25L7.5 17.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 11.25L10.5 17.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
